import request from '@/utils/request'

/**
 * 查询附件列表
 */
export function getAttachList(savePath, fromGuid) {
  return request({
    url: '/attach/list',
    method: 'get',
    params: { savePath, fromGuid }
  })
}

/**
 * 上传附件
 */
export function uploadAttach(formData, onProgress) {
  return request({
    url: '/attach/upload',
    method: 'post',
    data: formData,
    headers: { 'Content-Type': 'multipart/form-data' },
    onUploadProgress: onProgress
  })
}

/**
 * 删除附件（软删除）
 */
export function deleteAttach(guid) {
  return request({
    url: `/attach/${guid}`,
    method: 'delete'
  })
}

/**
 * 获取附件下载URL
 */
export function getAttachDownloadUrl(guid) {
  return `/api/attach/download/${guid}`
}
